export const AUTH_TOKEN = 'travelcabAdmWzToken';



// WEBPACK FOOTER //
// ./src/util/constants.js